// Все действующие станции метро СПб с точными координатами (OSM)
// Пересадочные узлы указаны одной записью с наиболее удобным входом
export const METRO_LIST = [
  // Линия 1 (красная)
  { id: 'm1',  name: 'Девяткино',                    lat: 60.050284, lng: 30.442670 },
  { id: 'm2',  name: 'Гражданский проспект',          lat: 60.034918, lng: 30.418279 },
  { id: 'm3',  name: 'Академическая',                lat: 60.012742, lng: 30.395844 },
  { id: 'm4',  name: 'Политехническая',              lat: 60.008983, lng: 30.371171 },
  { id: 'm5',  name: 'Площадь Мужества',             lat: 59.999624, lng: 30.366529 },
  { id: 'm6',  name: 'Лесная',                       lat: 59.985171, lng: 30.344650 },
  { id: 'm7',  name: 'Выборгская',                   lat: 59.971199, lng: 30.347189 },
  { id: 'm8',  name: 'Площадь Ленина',               lat: 59.956968, lng: 30.355552 },
  { id: 'm9',  name: 'Чернышевская',                 lat: 59.944442, lng: 30.360066 },
  { id: 'm10', name: 'Площадь Восстания',            lat: 59.931519, lng: 30.360568 },
  { id: 'm11', name: 'Владимирская',                 lat: 59.927455, lng: 30.348226 },
  { id: 'm12', name: 'Пушкинская',                   lat: 59.920687, lng: 30.330125 },
  { id: 'm13', name: 'Технологический институт',     lat: 59.916073, lng: 30.318890 },
  { id: 'm14', name: 'Балтийская',                   lat: 59.907350, lng: 30.300493 },
  { id: 'm15', name: 'Нарвская',                     lat: 59.900796, lng: 30.274825 },
  { id: 'm16', name: 'Кировский завод',              lat: 59.879641, lng: 30.261965 },
  { id: 'm17', name: 'Автово',                       lat: 59.867283, lng: 30.261002 },
  { id: 'm18', name: 'Ленинский проспект',           lat: 59.850711, lng: 30.268357 },
  { id: 'm19', name: 'Проспект Ветеранов',           lat: 59.841791, lng: 30.250259 },
  // Линия 2 (синяя)
  { id: 'm20', name: 'Парнас',                       lat: 60.066971, lng: 30.334000 },
  { id: 'm21', name: 'Проспект Просвещения',         lat: 60.051178, lng: 30.332680 },
  { id: 'm22', name: 'Озерки',                       lat: 60.037087, lng: 30.321557 },
  { id: 'm23', name: 'Удельная',                     lat: 60.016895, lng: 30.316292 },
  { id: 'm24', name: 'Пионерская',                   lat: 60.002886, lng: 30.296731 },
  { id: 'm25', name: 'Чёрная речка',                 lat: 59.985512, lng: 30.300838 },
  { id: 'm26', name: 'Петроградская',                lat: 59.966204, lng: 30.311702 },
  { id: 'm27', name: 'Горьковская',                  lat: 59.956148, lng: 30.318835 },
  { id: 'm28', name: 'Невский проспект',             lat: 59.935481, lng: 30.327107 },
  { id: 'm29', name: 'Сенная площадь',               lat: 59.927125, lng: 30.320547 },
  { id: 'm31', name: 'Фрунзенская',                  lat: 59.905880, lng: 30.317697 },
  { id: 'm32', name: 'Московские ворота',            lat: 59.891768, lng: 30.318047 },
  { id: 'm33', name: 'Электросила',                  lat: 59.879163, lng: 30.318705 },
  { id: 'm34', name: 'Парк Победы',                  lat: 59.866459, lng: 30.321853 },
  { id: 'm35', name: 'Московская',                   lat: 59.852019, lng: 30.322401 },
  { id: 'm36', name: 'Звёздная',                     lat: 59.833282, lng: 30.349444 },
  { id: 'm37', name: 'Купчино',                      lat: 59.829807, lng: 30.375456 },
  // Линия 3 (зелёная)
  { id: 'm38', name: 'Беговая',                      lat: 59.987820, lng: 30.202503 },
  { id: 'm39', name: 'Зенит',                        lat: 59.971777, lng: 30.211914 },
  { id: 'm40', name: 'Приморская',                   lat: 59.948460, lng: 30.234608 },
  { id: 'm41', name: 'Василеостровская',             lat: 59.942520, lng: 30.278278 },
  { id: 'm42', name: 'Гостиный двор',                lat: 59.933812, lng: 30.332447 },
  { id: 'm43', name: 'Маяковская',                   lat: 59.931448, lng: 30.355210 },
  { id: 'm44', name: 'Площадь Александра Невского',  lat: 59.924068, lng: 30.386925 },
  { id: 'm45', name: 'Елизаровская',                 lat: 59.896644, lng: 30.423775 },
  { id: 'm46', name: 'Ломоносовская',                lat: 59.877203, lng: 30.441955 },
  { id: 'm47', name: 'Пролетарская',                 lat: 59.865123, lng: 30.470324 },
  { id: 'm48', name: 'Обухово',                      lat: 59.848615, lng: 30.457815 },
  { id: 'm49', name: 'Рыбацкое',                     lat: 59.830857, lng: 30.500318 },
  // Линия 4 (оранжевая)
  { id: 'm50', name: 'Спасская',                     lat: 59.927094, lng: 30.320393 },
  { id: 'm51', name: 'Достоевская',                  lat: 59.928231, lng: 30.345967 },
  { id: 'm52', name: 'Лиговский проспект',           lat: 59.920963, lng: 30.355706 },
  { id: 'm53', name: 'Обводный канал',               lat: 59.914713, lng: 30.349703 },
  { id: 'm54', name: 'Волковская',                   lat: 59.896119, lng: 30.357770 },
  { id: 'm55', name: 'Бухарестская',                 lat: 59.883658, lng: 30.369539 },
  { id: 'm56', name: 'Международная',                lat: 59.870206, lng: 30.379296 },
  { id: 'm57', name: 'Проспект Славы',               lat: 59.856613, lng: 30.395446 },
  { id: 'm58', name: 'Дунайская',                    lat: 59.839865, lng: 30.410871 },
  { id: 'm59', name: 'Шушары',                       lat: 59.820100, lng: 30.432540 },
  // Линия 5 (фиолетовая)
  { id: 'm60', name: 'Комендантский проспект',       lat: 60.008573, lng: 30.258027 },
  { id: 'm61', name: 'Старая Деревня',               lat: 59.989212, lng: 30.255245 },
  { id: 'm62', name: 'Крестовский остров',           lat: 59.971819, lng: 30.259549 },
  { id: 'm63', name: 'Чкаловская',                   lat: 59.960960, lng: 30.292184 },
  { id: 'm64', name: 'Спортивная',                   lat: 59.950164, lng: 30.288069 },
  { id: 'm65', name: 'Адмиралтейская',               lat: 59.935979, lng: 30.315096 },
  { id: 'm66', name: 'Садовая',                      lat: 59.927168, lng: 30.317502 },
  { id: 'm67', name: 'Звенигородская',               lat: 59.922219, lng: 30.335400 },
  // Новые станции
  { id: 'm70', name: 'Путиловская',                  lat: 59.878699, lng: 30.264600 },
  { id: 'm72', name: 'Горный институт',              lat: 59.931751, lng: 30.262715 },
  { id: 'm73', name: 'Юго-Западная',                 lat: 59.859493, lng: 30.230700 },
  { id: 'm80', name: 'Новочеркасская',               lat: 59.928548, lng: 30.410973 },
  { id: 'm81', name: 'Ладожская',                    lat: 59.932429, lng: 30.439201 },
  { id: 'm82', name: 'Проспект Большевиков',         lat: 59.919784, lng: 30.466473 },
  { id: 'm83', name: 'Улица Дыбенко',                lat: 59.907457, lng: 30.483010 },
];

// Название из админки бывает с приставкой и с «ё»/«е» вперемешку:
// «м. Горьковская», «Чёрная речка» / «Черная речка»
const normalizeStation = (s) => String(s || '')
  .toLowerCase()
  .replace(/ё/g, 'е')
  .replace(/^\s*(м\.|метро|ст\.\s*м\.)\s*/, '')
  .trim();

// Дальше этого «ближайшая» станция — уже не та, от которой идут пешком
const NEAREST_STATION_MAX_M = 2500;

/**
 * Станция, от которой начинать путь к месту: по названию из поля `metro`
 * места, а если его нет или оно не нашлось — ближайшая по прямой,
 * но не дальше NEAREST_STATION_MAX_M. Загородное место — null
 */
export const findStartStation = (place) => {
  if (!place) return null;
  const wanted = normalizeStation(place.metro);
  if (wanted) {
    const byName = METRO_LIST.find((st) => normalizeStation(st.name) === wanted);
    if (byName) return byName;
  }
  if (place.latitude == null || place.longitude == null) return null;
  let best = null;
  let bestM = Infinity;
  METRO_LIST.forEach((st) => {
    const dy = (st.lat - place.latitude) * 110540;
    const dx = (st.lng - place.longitude) * 111320 * Math.cos((place.latitude * Math.PI) / 180);
    const m = Math.hypot(dx, dy);
    if (m < bestM) { bestM = m; best = st; }
  });
  return bestM <= NEAREST_STATION_MAX_M ? best : null;
};
